import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'patient',
  'export-patient-insurance-ehr-documents',
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'patient_insurances',
    'ehr',
    'document_exports',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/requests/export-patient-insurance-ehr-documents.js